<template>
  <path
    d="M7 10.0002V14.0002C7 14.5502 7.45 15.0002 8 15.0002H11L14.29 18.2902C14.92 18.9202 16 18.4702 16 17.5802V6.41017C16 5.52017 14.92 5.07017 14.29 5.70017L11 9.00017H8C7.45 9.00017 7 9.45017 7 10.0002Z"
  />
</template>
